import { partition, sortBy } from 'lodash-es'

import { LOCATION_MENU_STATUSES_SORT_VALUES } from '../../brands/constants'

const sortLocationByMenuStatusComparator = location =>
  LOCATION_MENU_STATUSES_SORT_VALUES[location.menuStatus].sortValue

const sortLocationsForMenuDefinitionTask = (locations, currentView) => {
  const locationsSortedById = sortBy(locations, 'id')

  const [
    locationsRequiringReview,
    locationsNotRequiringReview,
  ] = partition(locationsSortedById, location =>
    currentView.modifiedLocationIds.includes(Number(location.id)),
  )

  const [locationsWithMenuStatus, locationsWithoutMenuStatus] = partition(
    locationsNotRequiringReview,
    location => location.menuStatus,
  )

  const locationsWithMenuStatusSortedByMenuStatus = sortBy(
    locationsWithMenuStatus,
    sortLocationByMenuStatusComparator,
  )

  return [
    ...locationsRequiringReview,
    ...locationsWithoutMenuStatus,
    ...locationsWithMenuStatusSortedByMenuStatus,
  ]
}

export default sortLocationsForMenuDefinitionTask
